import React from 'react'

import {
  Box,
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core'

import confImg from 'images/configuracoes-03.png'

import useForm from 'react-hook-form'
import { RHFInput } from 'react-hook-form-input'
import { InputCurrency } from 'components/Form'
import { history, routes } from 'routes'
import { reverse } from 'named-urls'
import PaperHeader from './components/PaperHeader/PaperHeader'
import ContractPlanMigrateContext from 'contexts/ContractPlanMigrateContext'
import { useParams } from 'react-router-dom'

import schemas from './schemas'
import helpers from 'helpers'
import useRecurringCheck from 'hooks/useRecurringCheck'

const MigratePlanShow = () => {
  const params = useParams()
  const {
    handleChangeCheck,
    handleChangeQuantity,
    checkRecurrentValue,
  } = useRecurringCheck()
  const context = React.useContext(ContractPlanMigrateContext)
  const { register, setValue, errors, handleSubmit } = useForm({
    validationSchema: schemas.migratePlanConfig,
  })

  const onSubmit = async dataNew => {
    context.setData(data => ({
      ...data,
      newPlan: {
        price: dataNew.price,
        code: data.newPlan.code,
        periodicity: dataNew.periodicity || data.newPlan.periodicity,
        quantity: dataNew.quantity,
        description: data.newPlan.description,
        name: data.newPlan.name,
        contractPlanEntries: helpers.contractPlanEntries.normalizeSend([
          {
            quantity: dataNew.quantityDiscount,
            price: dataNew.discount,
          },
        ]),
      },
    }))

    history.push(
      reverse(routes.contracts.migratePlan.steps.confirm, {
        contractId: params.contractId,
        contractPlanId: params.contractPlanId,
      }),
    )
  }

  return (
    <Box p={{ xs: 2, sm: 4 }}>
      <Box>
        <PaperHeader title="Configurações do novo plano" />
        <Box mt={-2}>
          <Typography color="textSecondary">
            (baseadas nas configurações do plano antigo)
          </Typography>
        </Box>
      </Box>
      <Box
        display="flex"
        flexGrow={1}
        flexDirection={{
          xs: 'column',
          sm: 'row-reverse',
        }}
      >
        <Box
          display="flex"
          flex={1}
          flexDirection="row"
          justifyContent="center"
          alignItems="flex-start"
        >
          <img alt="Configuração" src={confImg} width="80%" />
        </Box>
        <Box
          display="flex"
          flex={1}
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <form onSubmit={handleSubmit(onSubmit)} id="new-plan-form">
            <Box mt={2}>
              <Typography color="textSecondary">
                Periodicidade da cobrança (de quanto em quanto tempo será
                cobrado?)
              </Typography>
            </Box>
            <RHFInput
              as={
                <TextField
                  label="Periodicidade"
                  SelectProps={{ native: true }}
                  size="small"
                  margin="dense"
                  select
                  error={!!errors.periodicity}
                  helperText={errors?.periodicity?.message}
                  fullWidth
                >
                  {helpers.plans.periodicityOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </TextField>
              }
              defaultValue={context.data.newPlan.periodicity}
              name="periodicity"
              register={register}
              setValue={setValue}
              mode="onChange"
            />
            <Box mt={2}>
              <Typography color="textSecondary">
                Quantas vezes será cobrado? (Ex: 12)
              </Typography>
            </Box>
            <RHFInput
              as={
                <TextField
                  label="Quantidade"
                  margin="dense"
                  type="number"
                  fullWidth
                  error={!!errors.quantity}
                  helperText={errors?.quantity?.message}
                  inputProps={{ min: 0 }}
                  disabled={checkRecurrentValue('quantity')}
                />
              }
              defaultValue={context.data.newPlan.quantity}
              name="quantity"
              register={register}
              setValue={setValue}
              onChange={e => handleChangeQuantity(e, 'quantity')}
              mode="onChange"
            />
            <FormControlLabel
              control={<Checkbox size="small" />}
              label={'Recorrente (tempo indeterminado)'}
              checked={checkRecurrentValue('quantity')}
              onChange={e => handleChangeCheck(e, 'quantity', setValue)}
            />
            <Box mt={2}>
              <Typography color="textSecondary">
                Valor de cada cobrança
              </Typography>
            </Box>
            <RHFInput
              as={
                <InputCurrency
                  label="Valor"
                  margin="dense"
                  fullWidth
                  error={!!errors.price}
                  helperText={errors?.price?.message}
                />
              }
              defaultValue={context.data.newPlan.price}
              name="price"
              register={register}
              setValue={setValue}
              mode="onChange"
            />
            <Box mt={4}>
              <Typography variant="h5" color="textSecondary">
                Desconto
              </Typography>
            </Box>
            <Box mt={2}>
              <Typography color="textSecondary">
                Quantas cobranças terão desconto? (Ex: 3)
              </Typography>
            </Box>
            <RHFInput
              as={
                <TextField
                  label="Quantidade"
                  margin="dense"
                  type="number"
                  fullWidth
                  error={!!errors.quantityDiscount}
                  helperText={errors?.quantityDiscount?.message}
                  inputProps={{ min: 0 }}
                  disabled={checkRecurrentValue('quantityDiscount')}
                />
              }
              name="quantityDiscount"
              register={register}
              setValue={setValue}
              onChange={e => handleChangeQuantity(e, 'quantityDiscount')}
              mode="onChange"
            />
            <FormControlLabel
              control={<Checkbox size="small" />}
              label={'Recorrente (tempo indeterminado)'}
              size="small"
              checked={checkRecurrentValue('quantityDiscount')}
              onChange={e => handleChangeCheck(e, 'quantityDiscount', setValue)}
            />
            <Box mt={2}>
              <Typography color="textSecondary">
                Informe o valor do desconto
              </Typography>
            </Box>
            <RHFInput
              as={
                <InputCurrency
                  label="Valor"
                  margin="dense"
                  fullWidth
                  error={!!errors.discount}
                  helperText={errors?.discount?.message}
                />
              }
              name="discount"
              register={register}
              setValue={setValue}
              mode="onChange"
            />
            <Box width={{ sm: 250 }} mt={4}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                size="large"
                fullWidth
              >
                Continuar
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
    </Box>
  )
}

export default MigratePlanShow
